"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BEAUTY_AND_TRENDS_MOBILE_LINK = exports.BEAUTY_AND_TRENDS_MOBILE = exports.BEAUTY_AND_TRENDS = void 0;
const BEAUTY_AND_TRENDS = exports.BEAUTY_AND_TRENDS = 'beauty-and-trends';
const BEAUTY_AND_TRENDS_MOBILE = exports.BEAUTY_AND_TRENDS_MOBILE = 'beauty-and-trends-mobile';
const BEAUTY_AND_TRENDS_MOBILE_LINK = exports.BEAUTY_AND_TRENDS_MOBILE_LINK = 'beauty-and-trends-mobile-link';